export default {
	data() {
		return {
			filterModel: ""
		};
	},
	watch: {
		"filterModel": {
			handler(val) {
				let fieldName = "model";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "string", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	}
};
